import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { createStore, applyMiddleware } from 'redux';
import rootReducer from './Reducers/rootReducer';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import thunk from 'redux-thunk';
import { getFirebase, ReactReduxFirebaseProvider } from 'react-redux-firebase';
import firebase from './config/firebaseConfig';
import { createFirestoreInstance } from 'redux-firestore';
import { useSelector } from 'react-redux';
import { isLoaded } from 'react-redux-firebase';
import './styles/style.css';
import './media/tablet.css';
import './media/mobile.css';

const store = createStore(
  rootReducer,
  applyMiddleware(thunk.withExtraArgument({
    getFirebase
  }))
);

// 🔐 1. CONFIGURATION DU PROFIL REDUX-FIREBASE
const rrfConfig = {
  userProfile: 'users',              // Nom de ta collection dans Firestore
  useFirestoreForProfile: true,     // 🎯 L'OPTION INDISPENSABLE : Active la lecture du profil sur Firestore
  updateProfileOnLogin: true        // Force le rechargement des droits à la connexion
};

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
};

function AuthIsLoaded({
  children
}) {
  const auth = useSelector((state) => state.firebase.auth);
  if (!isLoaded(auth))
    return (
      <div className = 'd-flex p-5 justify-content-center align-items-center min-vh-100'>
        <div className = 'spinner-border' style = {{ width: '7rem', height: '7rem' }} role = 'status'>
          <span className = 'visually-hidden' > Chargement... </span>
        </div>
      </div>
    );
  return children;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <GoogleOAuthProvider clientId="175891491778-pat26vhrc0pfefn3lmtuk3eh1h20o0e3.apps.googleusercontent.com">
    <Provider store = {store}>
      <ReactReduxFirebaseProvider { ...rrfProps }>
        <AuthIsLoaded>
          <App />
        </AuthIsLoaded>
      </ReactReduxFirebaseProvider>
    </Provider>
  </GoogleOAuthProvider>
);